import { useQuery } from '@tanstack/react-query';

import { getShippingCompanyList } from './index.2';
import { getShippingCompanyNameByCode, getShippingCompanyOptionList } from './shipping_company';

const fetchShippingCompanyList = async () => {
  try {
    const {
      data: { shipping_company_list },
    } = await getShippingCompanyList(undefined, { show_alert: false });
    return shipping_company_list;
  } catch (error: any) {
    console.error(error);
    const { code, exception } = error;
    throw { code: code || 500, message: exception?.message || '' };
  }
};
export function useGetShippingCompany(shipping_company_code?: string) {
  const { data } = useQuery({
    queryKey: ['fetchShippingCompanyList'],
    queryFn: fetchShippingCompanyList,
  });
  return {
    ...(shipping_company_code && {
      shipping_company_name: getShippingCompanyNameByCode(shipping_company_code, data),
    }),
    shipping_company_option_list: getShippingCompanyOptionList(data),
  };
}
